import { HttpService } from '../http.service'

const http = new HttpService()

export async function getDashboardUrl() {
  const result = await http.get<{
    url: string
  }>('embed/url?id=1')

  return result.data.url
}
